<template>
  <DialogForm
    ref="priceRequestDialogFormRef"
    should-send-gtm-generate-lead-event
    form-name="PriceRequestForm"
    :product="priceProduct"
  >
    <template #description>
      <ProductFormContact :subtitle="$t('shared.product.contact_form.price_request_subtitle', [priceProduct?.code])" />
    </template>
  </DialogForm>
</template>

<script setup lang="ts">
import { ref, onUnmounted } from "vue";
import { eventBus } from "@/shared/thorlabs/shared";
import type { Product } from "@/core/api/graphql/types";
import ProductFormContact from "@/shared/catalog/components/product/product-form-contact.vue";
import DialogForm from "@/shared/forms/components/dialog-form.vue";

const priceRequestDialogFormRef = ref<InstanceType<typeof DialogForm> | null>(null);
const priceProduct = ref<Product | undefined>(undefined);

eventBus.on("showPriceRequestDialog", (payload) => {
  priceProduct.value = { ...(payload.product as Product) };
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  priceRequestDialogFormRef.value?.showDialog();
});

onUnmounted(() => {
  eventBus.off("showPriceRequestDialog");
});
</script>
